/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import classNames from 'classnames';
import withValidation from '../../containers/withValidation';
import { fromAccountPropType } from '../../states/accounts/propTypes';
import withDescription from '../../containers/withDescription';
import CardSelector from '../CardSelector';
import AccountSelector from '../AccountSelector';

const getSelectedAccount = (accounts, accountId) => {
	const selectedAccount = find(accounts, (account) => account.id === accountId);
	if (selectedAccount) {
		return {
			displayName: selectedAccount.displayName,
			sortCode: selectedAccount.sortCode,
			type: selectedAccount.type,
			number: selectedAccount.number,
			accountNumber: selectedAccount.accountNumber,
			accountHolder: selectedAccount.accountHolder,
		};
	}
	return selectedAccount;
};

class FromAccount extends Component {
	constructor(props) {
		super(props);
		this.onAccountSelect = this.onAccountSelect.bind(this);
	}
	onAccountSelect(accountId) {
		const { fromAccounts, handleSelectFromAccount, handleCardClick } = this.props;
		handleCardClick();
		handleSelectFromAccount(accountId, fromAccounts);
	}
	render() {
		const {
			id,
			fromAccount,
			fromAccounts,
			handleCardClick,
			showAccountSelector,
			title,
			disable,
			noIcon,
			isFocusOn,
			onBlur,
		} = this.props;

		const iconType = noIcon ? '' : 'PlusOutlineLarge';
		return (
			<div className="c-o-list-payment__input-wrap">
				<div className="c-m-payment-control">
					<div
						className={classNames({
							'c-m-payment-control__field': true,
							'c-m-payment-control__field--is-active': showAccountSelector,
						})}
					>
						<CardSelector
							id={`field-from-account-${id}`}
							title={title}
							iconType={iconType}
							onClick={() => handleCardClick(id)}
							disabled={disable}
							selectedAccount={getSelectedAccount(fromAccounts, fromAccount)}
							isFocusOn={isFocusOn}
							onBlur={onBlur}
						/>
						{showAccountSelector && (
							<AccountSelector
								title="Your accounts"
								accounts={fromAccounts}
								onAccountSelect={this.onAccountSelect}
								selectedAccountId={fromAccount}
							/>
						)}
						<div
							className={classNames('c-m-payment-account-selector__dismissal', {
								'c-m-payment-account-selector__dismissal--is-visible': showAccountSelector,
							})}
							onClick={handleCardClick}
						/>
					</div>
				</div>
			</div>
		);
	}
}

FromAccount.defaultProps = {
	title: 'From',
};

FromAccount.propTypes = {
	fromAccount: PropTypes.string,
	showAccountSelector: PropTypes.bool,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	id: PropTypes.string.isRequired,
	handleSelectFromAccount: PropTypes.func.isRequired,
	handleCardClick: PropTypes.func.isRequired,
	title: PropTypes.string,
	disable: PropTypes.bool,
	noIcon: PropTypes.bool,
	isFocusOn: PropTypes.bool,
	onBlur: PropTypes.func,
};

export { FromAccount };
export const DestinationAccount = withValidation({
	validations: ['required'],
	key: 'fromAccount',
	message: 'Select a to account for this payment.',
})(withDescription(FromAccount));

export default withValidation({
	validations: ['required'],
	key: 'fromAccount',
	message: 'Select a from account for this payment.',
})(withDescription(FromAccount));
